import { Button } from 'antd';
import React from 'react';
import StyledError from './styled';
import { Heading } from '../../styled';

const ErrorContainer = ({ setShowError, showError, setFileList }) => {
  if (!showError) return null;

  const resetForm = () => {
    setShowError(false);
    setFileList(null);
  };

  return (
    <StyledError>
      <Heading>Oops!</Heading>

      <p>Something went wrong, the file was not processed.</p>

      <Button key="submit" type="primary" onClick={resetForm}>
        Try again
      </Button>
    </StyledError>
  );
};

export default ErrorContainer;
